<template>
  <div v-if="visible" class="cookie-banner shadow-lg">
    <div class="cookie-banner__inner">
      <div class="cookie-banner__text">
        <div class="cookie-banner__title">Slapukai ir privatumas</div>
        <div class="cookie-banner__body">
          Naudojame būtinuosius slapukus svetainės veikimui. Taip pat galime įkelti trečiųjų šalių turinį (pvz. „Google Maps“) tik su Jūsų sutikimu.
          <a class="cookie-banner__link" href="#" @click.prevent="openPrivacy">Privatumo politika</a>
          ·
          <a class="cookie-banner__link" href="#" @click.prevent="openCookies">Slapukų politika</a>
        </div>
      </div>

      <div class="cookie-banner__actions">
        <button class="btn btn-outline-light btn-sm" @click="rejectAll">Atmesti</button>
        <button class="btn btn-light btn-sm" @click="acceptNecessary">Tik būtini</button>
        <button class="btn btn-danger btn-sm" @click="acceptAll">Sutikti</button>
      </div>
    </div>
  </div>
</template>

<script>
import { getConsent, setConsent } from '@/utils/consent'

export default {
  name: 'CookieBanner',
  data() {
    return {
      visible: false,
      consent: getConsent()
    }
  },
  mounted() {
    // Show banner if user hasn't made a choice yet (no stored value)
    try {
      this.visible = localStorage.getItem('arunvilkasa_consent_v1') == null
    } catch (e) {
      this.visible = true
    }

    window.addEventListener('arunvilkasa:open-cookie-settings', this.open)
  },
  beforeUnmount() {
    window.removeEventListener('arunvilkasa:open-cookie-settings', this.open)
  },
  methods: {
    open() {
      this.visible = true
      this.consent = getConsent()
    },
    close() {
      this.visible = false
    },
    openPrivacy() {
      this.$emit('open-privacy')
    },
    openCookies() {
      this.$emit('open-cookies')
    },
    acceptNecessary() {
      setConsent({ necessary: true, external: false, analytics: false })
      this.close()
    },
    rejectAll() {
      setConsent({ necessary: true, external: false, analytics: false })
      this.close()
    },
    acceptAll() {
      setConsent({ necessary: true, external: true, analytics: true })
      this.close()
    }
  }
}
</script>

<style scoped>
.cookie-banner {
  position: fixed;
  left: 16px;
  right: 16px;
  bottom: 16px;
  z-index: 9999;
  background: rgba(20, 20, 20, 0.95);
  color: #fff;
  border-radius: 14px;
  border: 1px solid rgba(255, 255, 255, 0.12);
}
.cookie-banner__inner {
  display: flex;
  gap: 16px;
  align-items: center;
  justify-content: space-between;
  padding: 14px 14px;
}
.cookie-banner__title {
  font-weight: 700;
  margin-bottom: 4px;
}
.cookie-banner__body {
  font-size: 0.9rem;
  opacity: 0.95;
}
.cookie-banner__link {
  color: #fff;
  text-decoration: underline;
}
.cookie-banner__actions {
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
  justify-content: flex-end;
  min-width: 260px;
}
@media (max-width: 768px) {
  .cookie-banner__inner {
    flex-direction: column;
    align-items: stretch;
  }
  .cookie-banner__actions {
    justify-content: flex-start;
    min-width: auto;
  }
}
</style>


